import { ReactNode } from "react";

import ModalHeader from "./ModalHeader";
import ModalOverlay from "./ModalOverlay";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  description?: string;
  children: ReactNode;
  /** Largura máxima do painel (Tailwind, ex.: max-w-lg) */
  panelClassName?: string;
  bodyClassName?: string;
  compactHeader?: boolean;
}

const Modal = ({
  isOpen,
  onClose,
  title,
  description,
  children,
  panelClassName,
  bodyClassName,
  compactHeader = false,
}: ModalProps) => {
  if (!isOpen) return null;

  return (
    <ModalOverlay panelClassName={panelClassName}>
      <ModalHeader
        title={title}
        description={description}
        onClose={onClose}
        padding={compactHeader ? "p-4" : "p-6"}
      />
      <div
        className={
          bodyClassName ??
          "min-h-0 flex-1 overflow-y-auto overscroll-contain p-6"
        }
      >
        {children}
      </div>
    </ModalOverlay>
  );
};

export default Modal;
